<template>
    <div class="flex pb3 items-center">

        <!-- currencyInput -->
        <div class="w-40 mr3">
            <CurrencyInput v-model="customRate.rate" class="w-40 mr3"/>
        </div>

        <!-- dash -->
        <h6>/</h6>

        <!-- time input -->
        <div class="ml3 w-40 w-25-ns">
            <select class="th pl2 w-100" v-model="customRate.timeFrame">
                <option value="4">4 hours</option>
                <option value="12">12 hours</option>
                <option value="72">3 days</option>
            </select>
        </div>
        <!-- remove button -->
        <img @click="$emit('delete')" class="pointer grow ml2 ml4-ns" src="@/assets/img/icon_listmytools_remove.svg"/>

    </div>
</template>

<script>
import CurrencyInput from '@/components/controls/CurrencyInput.vue';
import Dropdown from '@/components/controls/Dropdown.vue';

export default {
    props: {
        customRate: {
            type: Object
        }
    },
    components: {
        CurrencyInput,
        Dropdown
    }
};
</script>
